var r = /* @__PURE__ */ ((e) => (e.BulletList = "bulletList", e.OrderedList = "orderedList", e))(r || {});
export {
  r as ListEnum
};
